
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/p/[slug]/[id]",
      function () {
        return require("private-next-pages/p/[slug]/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/p/[slug]/[id]"])
      });
    }
  